module.exports = __webpack_public_path__ + "img/全部销毁.6891eeb6.png";